import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Outlet, useSearchParams } from "react-router-dom";

import { SpinnerLoader } from "../../components/widgets/spinner-loader/SpinnerLoader";
import { createProject, getProject } from "./simple-prompt-studio-api-service";
import { useCustomToolStore } from "../../store/custom-tool-store";
import { InvalidIdPage } from "./InvalidIdPage";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";
import { SPS_ID } from "./constants";

function SimplePromptStudioHelper() {
  const [isLoading, setIsLoading] = useState(true);
  const [isInvalidProject, setIsInvalidProject] = useState(false);
  const [refreshProject, setRefreshProject] = useState(false);
  const [searchParams] = useSearchParams();
  const { updateCustomTool, details } = useCustomToolStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  useEffect(() => {
    // Return early if project details already exist
    if (Object.keys(details)?.length) {
      return;
    }

    // Get projectId from searchParams or cookies
    let projectId = searchParams.get(SPS_ID);
    if (!projectId) {
      projectId = Cookies.get(SPS_ID);
    }

    setIsLoading(true);

    if (projectId) {
      // Fetch project details if projectId exists
      getProject(projectId)
        .then((res) => {
          handleAction(res?.data);
        })
        .catch((err) => {
          setIsInvalidProject(true);
          setAlertDetails(handleException(err));
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // Create new project if no projectId is found
      createProject()
        .then((res) => {
          handleAction(res?.data);
        })
        .catch((err) => {
          setIsInvalidProject(true);
          setAlertDetails(handleException(err));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [refreshProject]);

  // Handle the actions to be performed after getting or creating project
  const handleAction = (data) => {
    const docs = data?.documents || [];
    const spsDetails = {
      listOfDocs: docs,
      details: data,
      isSimplePromptStudio: true,
    };

    updateCustomTool(spsDetails);
    Cookies.set(SPS_ID, data?.tool_id); // Set projectId in cookies
  };

  if (isLoading) {
    return <SpinnerLoader />;
  }

  if (isInvalidProject) {
    return <InvalidIdPage setRefreshProject={setRefreshProject} />;
  }

  return <Outlet />;
}

export { SimplePromptStudioHelper };
